var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12221_2023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8626 9.20637L10.2059 16.8631C9.26792 17.8011 7.99572 18.328 6.66919 18.328C5.34265 18.328 4.07045 17.8011 3.13245 16.8631C2.19444 15.9251 1.66748 14.6529 1.66748 13.3263C1.66748 11.9998 2.19444 10.7276 3.13245 9.78958L10.7891 2.13289C11.4145 1.50756 12.2626 1.15625 13.147 1.15625C14.0313 1.15625 14.8795 1.50756 15.5048 2.13289C16.1301 2.75823 16.4814 3.60636 16.4814 4.49072C16.4814 5.37508 16.1301 6.22321 15.5048 6.84855L7.83977 14.5052C7.5271 14.8179 7.10303 14.9936 6.66085 14.9936C6.21868 14.9936 5.79461 14.8179 5.48194 14.5052C5.16927 14.1926 4.99362 13.7685 4.99362 13.3263C4.99362 12.8841 5.16927 12.4601 5.48194 12.1474L12.5554 5.08226",
    stroke: "#6B7280",
    strokeWidth: 1.66631,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12221_2023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9957,
    height: 19.9957,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/attachment_icon.7200e6caffaae47f494a775279238540.svg";
export { ForwardRef as ReactComponent };